import axios from 'axios';

export default {
    getUserRoles() {
        return axios.get(window.API_BASE + '/user-roles');
    }
}